import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  Component,
  ViewChild,
  ElementRef,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PlaylistApi } from 'app/modules/dashboard/api/playlist.api';
import { Subscription } from 'rxjs';
import { RippleModule } from 'primeng/ripple';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { BlackColorsRef, IconComponent } from '@kinomap-dev/ng-ui-lib';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorConfig } from 'ckeditor5';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CKEditorConfig } from 'app/configs/ckeditorConfig';

@Component({
  selector: 'app-new-playlist-modal',
  templateUrl: './watchNewPlaylistModal.component.html',
  styleUrls: ['./watchNewPlaylistModal.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    TranslateModule,
    FormsModule,
    RippleModule,
    IconComponent,
    CKEditorModule,
  ],
})
export class WatchNewPlaylistModalComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  xSmallScreen: boolean;

  // Form Variables
  name: string = '';
  desc: string | null = null;
  isPublic: boolean = false;
  logoFile: File | null = null;
  logoSrc: string | ArrayBuffer;
  bannerFile: File | null = null;
  bannerSrc: string | ArrayBuffer;
  isValid: boolean = false;
  trashColor: string = BlackColorsRef.black_200;
  editor: typeof ClassicEditor = ClassicEditor;
  config: EditorConfig = {};

  @Input() type: string;
  @Input() videoId!: number;
  @Output() close: EventEmitter<string>;

  @ViewChild('inputBanner', { static: true }) inputBannerRef!: ElementRef;
  @ViewChild('inputLogo', { static: true }) inputLogoRef!: ElementRef;

  constructor(
    private responsive: BreakpointObserver,
    private playlistApi: PlaylistApi,
    public readonly translate: TranslateService
  ) {
    this.close = new EventEmitter<string>();
  }

  switchClick(): void {
    this.isPublic = !this.isPublic;
  }

  getTranslation(text: string): string {
    return this.translate.instant(text);
  }

  loadImage(event: any, fileType: 'logo' | 'banner'): void {
    const fileList: FileList = event.target.files;

    if (fileList.length > 0) {
      const selectedFile: File = fileList[0];
      const reader: FileReader = new FileReader();
      reader.readAsDataURL(selectedFile);

      if (
        selectedFile.type === 'image/jpeg' ||
        selectedFile.type === 'image/png'
      ) {
        if (fileType === 'logo') {
          this.logoFile = selectedFile;
          reader.onload = (event) => {
            this.logoSrc = event.target.result;
          };
        } else if (fileType === 'banner') {
          this.bannerFile = selectedFile;
          reader.onload = (event) => {
            this.bannerSrc = event.target.result;
          };
        }
      } else {
        console.error(
          "Le fichier sélectionné n'est pas au format JPEG ou PNG."
        );
      }
    }
  }

  remove(fileType: 'logo' | 'banner'): void {
    if (fileType === 'logo') {
      this.logoFile = null;
      this.inputLogoRef.nativeElement.value = '';
      return (this.logoSrc = null);
    }

    this.inputBannerRef.nativeElement.value = '';
    this.bannerFile = null;
    return (this.bannerSrc = null);
  }

  sendPlaylist(): void {
    let videoType: string;
    let trainingMode: string;
    switch (this.type) {
      case 'watch':
      case 'scenic':
        videoType = 'section';
        trainingMode = 'scenic';
        break;
      case 'coaching':
        videoType = 'coaching';
        trainingMode = 'coaching';
        break;
    }

    if (
      (!this.isPublic && this.name !== '') ||
      (this.isPublic && this.logoFile && this.bannerFile && this.name !== '')
    ) {
      this.playlistApi
        .createNewPlaylist(
          this.name,
          this.desc,
          this.isPublic ? 'public' : 'private',
          this.bannerFile,
          this.logoFile,
          this.videoId,
          trainingMode,
          videoType
        )
        .subscribe(() => {
          this.close.emit(this.name);
        });
    }
  }

  ngOnInit(): void {
    this.config = CKEditorConfig;
    this.subscriptions = [
      ...this.subscriptions,
      // RESPONSIVE SUBSCRIPTIONS :
      this.responsive.observe(Breakpoints.XSmall).subscribe((result) => {
        this.xSmallScreen = result.matches ? true : false;
      }),
    ];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
